// ==============================|| OVERRIDES - TAB ||============================== //

export default function Tab(theme) {
  return {
    MuiTab: {
      styleOverrides: {
        root: {
          '&.Mui-selected': {
            color: '#FFFFFF',
            backgroundColor: 'dimgrey',
            borderRadius: '10px',
            transition: 'all 500ms ease',
          },
          minHeight: 46,
          color: theme.palette.text.primary,
        },
      },
    },
  };
}
